<template>
  <div id="root"
       :class="app_theme_brand"
       class="root">
    <div class="root__body">
      <div class="content_wrapper">
        <main id="stepper"
              :class="'current-step-'+currentStep"
              class="stepper">
          <div class="progress">
            <button v-for="(step, index) in steps"
                    :key="index"
                    :class="{active: currentStep === step.id, 'icon icon--check': step.id === steps.length, completed: currentCompletedStep >= step.id}"
                    class="progress__btn"
                    v-html="step.id === steps.length ? '' : `<span>${step.id}</span><span>${step.title}</span>`" />
          </div>
          <div v-for="(stepTitle, index) in appData.stepTitles"
               :key="index"
               :class="{active: currentStep >= index+2}"
               class="stepper-not-current"
               @click="_handleStepProgress(index+1)"
               v-html="currentStep <= index+1 ? '' : `<span>${stepTitle.title}</span>`"/>

          <SlideYUpTransition :duration="stepTransitionDuration"
                              mode="out-in"
                              group>

            <Steps v-for="(step, index) in steps"
                   v-if="currentStep === index + 1"
                   :key="index + 1"
                   class="stepper__step">

              <div v-show="currentStep === 1">
                <h4 class="stepper__title"><span class="mobile-hidden">1.</span> Behandlungsspektrum / Patientenstruktur</h4>
                <div class="content-block first-containers-wrapper">
                  <div class="first-container content-container half-input-list">
                    <h4>Welche Behandlungsleistungen bieten Sie in Ihrer Praxis an?</h4>
                    <span v-for="(services, key) in appData.s1.services"
                          :key="key"
                          class="half-input input-s1-services">
                      <checkbox :value="`${services}`"
                                :id="`s1-checkbox-services-${key+1}`"
                                v-model="appData.s1.servicesSelected"
                                name="checkbox-services"
                                type='checkbox'
                                @input="handleServicesList($event)">
                        {{ services }}
                      </checkbox>
                    </span>
                  </div>
                  <div class="second-container">
                    <h4>Entfallen von den Behandlungsumsätzen ca. 30% oder mehr auf folgende Behandlungen:</h4>
                    <div class="container-wrapper">
                      <div class="half-input-list">
                        <div class="input-list-title">Implantologie</div>
                        <v-select class="s-select" name='select-implantologie' v-model="appData.s1.implantologyValue" :options="appData.s1.implantology" label="name" placeholder="Select"></v-select>
                      </div>
                      <div class="half-input-list">
                        <div class="input-list-title">Kieferorthopädie</div>
                        <v-select class="m-select" name='select-orthodontics' v-model="appData.s1.orthodonticsValue" :options="appData.s1.orthodontics" label="name" placeholder="Select"></v-select>
                      </div>
                    </div>
                    <div class="container-wrapper">
                      <div>
                        <checkbox v-model="appData.s1.implantologyOther"
                                  type="checkbox">
                          Sonstige
                        </checkbox>
                      </div>
                    </div>
                    <div v-show="appData.s1.implantologyOther == true">
                      <span class='input-list-title' style='display: block;'>Sonstige Angaben</span>
                      <input v-model="appData.s1.implantologyOtherValue"
                             class="custom_input large"
                             type="text"
                             name="input-implantology"
                             placeholder="Platz für weitere Leistungen...">
                    </div>
                  </div>
                  <div class="third-container">
                    <div>
                        <h4>Anteil der Privatpatienten</h4>
                        <v-select class="l-select" name='select-angaben' v-model="appData.s1.angabenValue" :options="appData.s1.angaben" label="name" placeholder="Select"></v-select>
                    </div>
                    <div>
                      <h4>Durschnittliche Anzahl an Scheinen pro Quartal</h4>
                      <v-select class="l-select" name='select-bills' v-model="appData.s1.billsValue" :options="appData.s1.bills" label="name" placeholder="Select"></v-select>
                    </div>
                  </div>
                </div>
              </div>

              <div v-show="currentStep === 2">
                <h4 class="stepper__title"><span class="mobile-hidden">2.</span> Praxisstruktur</h4>
                <div class="second-containers-wrapper content-block">
                  <div class="first-container">
                    <div>
                      <h4>Über wie viele zahnmedizinische Behandlungszimmer verfügt Ihre Praxis?</h4>
                      <v-select class="m-select" name='select-rooms' v-model="appData.s2.roomsValue" :options="appData.s2.rooms" label="name" placeholder="Select"></v-select>
                    </div>
                    <div>
                      <h4>Sind alle Behandlungszimmer den Leistungen entsprechend ausgestattet?</h4>
                      <v-select class="m-select" name='select-rooms-equipment' v-model="appData.s2.roomsEquipmentValue" :options="appData.s2.roomsEquipment" label="name" placeholder="Select"></v-select>
                    </div>
                    <div>
                      <h4>Gibt es die Möglichkeit weitere Behandlungszimmer hinzuzufügen?</h4>
                      <v-select class="m-select" name='select-more-rooms' v-model="appData.s2.moreRoomsValue" :options="appData.s2.moreRooms" label="name" placeholder="Select"></v-select>
                    </div>
                    <div v-if="appData.s2.moreRoomsValue.name == 'Ja'" class="">
                      <h4>Ist die Erweiterung der Behandlungszimmer mit einem geringen oder hohen Aufwand verbunden? <div v-tooltip="tooltipContent.s2col3" class="icon icon--help fas fa-question-circle"></div></h4>
                      <v-select class="l-select" name='select-more-rooms' v-model="appData.s2.moreRoomsSecondValue" :options="appData.s2.moreRoomsSecond" label="name" placeholder="Select"></v-select>
                    </div>
                  </div>
                  <div class="second-container">
                    <div class="">
                      <h4>Praxisgeräte <div v-tooltip="tooltipContent.s2col1" class="icon icon--help fas fa-question-circle"></div></h4>
                      <p>
                        Bitte bewerten Sie den Zustand Ihrer Praxisausstattung (alle für eine zahnmedizinische Behandlung notwendigen Gerätschaften und Anlagen) auf einer Skala von 1 bis 5, wobei 5 einen idealen Zustand beschreibt.
                      </p>
                      <div class="ausstattung-radio-container">
                        <div class="name-changer-container">
                          <button class="option-name-changer minus" :class="{ 'disabled-changer': appData.s2.ausstattungValue == 1 }" @click="decrementOptionNameAusstattung"></button>
                          <input readonly class="option-name-input" type="text" v-model="appData.s2.ausstattungValue" />
                          <button class="option-name-changer plus" :class="{ 'disabled-changer': appData.s2.ausstattungValue == 5 }" @click="incrementOptionNameAusstattung"></button>

                        </div>
                      </div>
                    </div>
                    <div class="second-ratings">
                      <h4>Praxiseinrichtung <div v-tooltip="tooltipContent.s2col2" class="icon icon--help fas fa-question-circle"></div></h4>
                      <p class="">
                        Bitte bewerten Sie den Zustand Ihrer Praxiseinrichtung (darunter fallen Einrichtungsgegenstände, die kein Bestandteil der zahnärztlichen Behandlung sind, z.B. Rezeption, Wartezimmer) auf einer Skala von 1 bis 5, wobei 5 einen idealen Zustand beschreibt.
                      </p>
                      <div class="ausstattung-radio-container">
                        <div class="name-changer-container">
                          <button class="option-name-changer minus" :class="{ 'disabled-changer': appData.s2.einrichtungValue == 1 }" @click="decrementOptionNameEinrichtung"></button>
                          <input readonly class="option-name-input" type="text" v-model="appData.s2.einrichtungValue" />
                          <button class="option-name-changer plus" :class="{ 'disabled-changer': appData.s2.einrichtungValue == 5 }" @click="incrementOptionNameEinrichtung"></button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="third-container">
                    <div class="">
                      <h4>Anzahl Mitarbeiter insgesamt (in FTE)</h4>
                      <div class="input-list-title">ZA, ZFA, ZMV, Reinigungskraft etc.</div>
                      <v-select class="m-select" name='select-employees' v-model="appData.s2.employeesValue" :options="appData.s2.employees" label="name" placeholder="Select"></v-select>
                    </div>
                    <div class="">

                      <h4>Anzahl Zahnärzte (in FTE)</h4>
                      <div class="name-changer-container">
                        <button class="option-name-changer minus" :class="{ 'disabled-changer': appData.s2.emplyoeesDentists == 0 }" @click="decrementAnzahl"></button>
                        <input readonly class="option-name-input"
                               min="0"
                               max="10"
                               step="1"
                               name="input-employees-dentists" type="text" v-model="appData.s2.emplyoeesDentists" />
                        <button class="option-name-changer plus" :class="{ 'disabled-changer': appData.s2.emplyoeesDentists == 10 }" @click="incrementAnzahl"></button>

                      </div>
                    </div>
                    <div class="">
                      <h4>Ist in Ihrer Praxis ein funktionsfähiges Eigenlabor mit angestellten Technikern implementiert?</h4>
                      <v-select class="m-select" name='select-labaratory' v-model="appData.s2.labaratoryValue" :options="appData.s2.labaratory" label="name" placeholder="Select"></v-select>
                    </div>
                    <div v-if="appData.s2.labaratoryValue.name == 'Ja'" class="">
                      <h4>Wie viele Mitarbeiter sind in Ihrem Eigenlabor beschäftigt?</h4>
                      <div class="name-changer-container">
                        <button class="option-name-changer minus" :class="{ 'disabled-changer': appData.s2.labaratoryEmployees == 0 }" @click="decrementLabaratory"></button>
                        <input readonly class="option-name-input"
                               min="0"
                               max="10"
                               step="1"
                               name="input-labaratory-employees" type="text" v-model="appData.s2.labaratoryEmployees" />
                        <button class="option-name-changer plus" :class="{ 'disabled-changer': appData.s2.labaratoryEmployees == 5 }" @click="incrementLabaratory"></button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-show="currentStep === 3">
                <h4 class="stepper__title"><span class="mobile-hidden">3.</span> Finanzdaten der Praxis</h4>
                <div class="content-block third-containers-wrapper">
                  <div class="first-container">
                    <div class="">
                      <h4>Praxisumsatz des letzten, abgeschlossenen Geschäftsjahres</h4>
                      <div class="input-list-title">laut BWA oder Jahresabschluss</div>
                      <v-select class="xl-select" name='select-turnover' v-model="appData.s3.turnoverValue" :options="appData.s3.turnover" label="name" placeholder="Select"></v-select>
                    </div>
                    <div class="">
                      <h4>Jahresüberschuss der Praxis im letzten, abschlossenen Geschäftsjahr</h4>
                      <div class="input-list-title">laut BWA oder Jahresabschluss</div>
                      <v-select class="xl-select" name='select-surplus' v-model="appData.s3.surplusValue" :options="appData.s3.surplus" label="name" placeholder="Select"></v-select>
                    </div>
                    <div class="">
                      <h4>Honorarumsatz des Praxisinhabers in Relation zum Gesamtumsatz</h4>
                      <v-select class="xl-select" name='select-sales-dependency' v-model="appData.s3.salesDependencyValue" :options="appData.s3.salesDependency" label="name" placeholder="Select"></v-select>
                    </div>
                    <div class="">
                      <h4>Anteil des Prophylaxe-Umsatzes am Gesamtumsatz</h4>
                      <v-select class="xl-select" name='select-sales-share' v-model="appData.s3.salesShareValue" :options="appData.s3.salesShare" label="name" placeholder="Select"></v-select>
                    </div>
                    <div class="">
                      <h4>Fremdlaborkosten im Jahr</h4>
                      <v-select class="xl-select" name='select-external-labaratory-turnover' v-model="appData.s3.externalLabaratoryTurnoverValue" :options="appData.s3.externalLabaratoryTurnover" label="name" placeholder="Select"></v-select>
                    </div>
                  </div>
                </div>
              </div>

              <div v-show="currentStep === 4">
                <h4 class="stepper__title"><span class="mobile-hidden">4.</span> Nachfolge</h4>
                <div class="content-block third-containers-wrapper">
                  <div class="first-container">
                    <div class="">
                      <h4>Arbeitsbereitschaft nach Praxisverkauf</h4>
                      <div class="input-list-title">Wie lange sind Sie als Inhaber nach Verkauf Ihrer  Praxis bereit weiter in dieser tätig zu bleiben?</div>
                      <v-select class="xl-select" name='select-work-after-sale' v-model="appData.s4.workAfterSaleValue" :options="appData.s4.workAfterSale" label="name" placeholder="Select"></v-select>
                    </div>
                    <div class="">
                      <h4>Angestrebter zeitlicher Rahmen einer Nachfolgelösung</h4>
                      <div class="input-list-title">In wie vielen Monaten wollen Sie Ihre Praxis verkaufen?</div>
                      <v-select class="xl-select" name='select-solution-timeframe' v-model="appData.s4.solutionTimeframeValue" :options="appData.s4.solutionTimeframe" label="name" placeholder="Select"></v-select>
                    </div>
                    <div class="">
                      <h4>Anzahl der Gesellschafter</h4>
                      <v-select class="xl-select" name='select-solution-timeframe' v-model="appData.s4.numberOfPartnersValue" :options="appData.s4.numberOfPartners" label="name" placeholder="Select"></v-select>
                    </div>
                    <div class="">
                      <h4>Praxis-Typ</h4>
                      <v-select class="xxl-select" name='select-solution-timeframe' v-model="appData.s4.practiceTypeValue" :options="appData.s4.practiceType" label="name" placeholder="Select"></v-select>
                    </div>
                  </div>
                </div>
              </div>

              <div v-show="currentStep === 5">
                <div>
                  <h4 class="stepper__title"><span class="mobile-hidden">5.</span> Kontaktdaten</h4>
                </div>
                <div class="content-block contact-form">
                  <h4>Bitte hinterlassen Sie uns Ihre Kontaktdaten, damit wir Ihnen Ihre individuelle Praxisbewertung zukommen lassen können.</h4>
                  <form id="mailform"
                        name="mailform"
                        enctype="multipart/form-data"
                        method="post"
                        target="_top">
                    <div class="first-column">
                      <div class="stepper__input">
                        <div class="field">
                          <div class="field-title">Anrede</div>
                          <v-select class="xxl-select" v-validate="'required'" id="mailformAnrede" :class="{'input': true, 'is-danger': errors.has('Anrede')}" name='select-solution-timeframe'  v-model.lazy="appData.contact.anrede" name="Anrede" :options="['Frau', 'Herr', 'Divers']" label="name" placeholder="Select"></v-select>
                          <span v-show="errors.has('Anrede')"
                                class="icon icon--sort-up help is-danger">Anrede ist ein Pflichtfeld.</span>
                        </div>
                        <div class="field">
                          <div class="field-title">Titel</div>
                          <input :class="{'input': true, 'is-danger': errors.has('Titel') }"
                                 v-model.lazy="appData.contact.titel"
                                 type="text"
                                 name="Titel">
                          <span v-show="errors.has('Titel')"
                                class="icon icon--sort-up help is-danger">Titel ist ein Pflichtfeld.</span>
                        </div>
                      </div>

                      <div class="stepper__input">
                        <div class="field">
                          <div class="field-title">Vorname</div>
                          <input v-validate="'required'"
                                 :class="{'input': true, 'is-danger': errors.has('Vorname') }"
                                 v-model.lazy="appData.contact.firstname"
                                 type="text"
                                 name="Vorname">
                          <span v-show="errors.has('Vorname')"
                                class="icon icon--sort-up help is-danger">Vorname ist ein Pflichtfeld.</span>
                        </div>

                        <div class="field">
                          <div class="field-title">Nachname</div>
                          <input v-validate="'required'"
                                 :class="{'input': true, 'is-danger': errors.has('Nachname') }"
                                 v-model.lazy="appData.contact.lastname"
                                 name="Nachname"
                                 type="text">
                          <span v-show="errors.has('Nachname')"
                                class="icon icon--sort-up help is-danger">Nachname ist ein Pflichtfeld.</span>
                        </div>
                      </div>

                      <div class="stepper__input">
                        <div class="field">
                          <div class="field-title">Firma</div>
                          <input v-validate="'required'"
                                 :class="{'input': true, 'is-danger': errors.has('Firma') }"
                                 v-model.lazy="appData.contact.firma"
                                 name="Firma"
                                 type="text">
                          <span v-show="errors.has('Firma')"
                                class="icon icon--sort-up help is-danger">Firma ist ein Pflichtfeld.</span>
                        </div>

                        <div class="field">
                          <div class="field-title">Position</div>
                          <input v-validate="'required'"
                                 :class="{'input': true, 'is-danger': errors.has('position') }"
                                 v-model.lazy="appData.contact.position"
                                 name="position"
                                 type="text">
                          <span v-show="errors.has('position')"
                                class="icon icon--sort-up help is-danger">Position ist ein Pflichtfeld.</span>
                        </div>
                      </div>

                      <div class="stepper__input">
                        <div class="field">
                          <div class="field-title">Email</div>
                          <input v-validate="'required|email'"
                                 :class="{'input': true, 'is-danger': errors.has('Email') }"
                                 v-model.lazy="appData.contact.email"
                                 name="Email"
                                 type="text">
                          <span v-show="errors.has('Email')"
                                class="help is-danger icon icon--sort-up">Email ist ein Pflichtfeld.</span>
                        </div>

                        <div class="field">
                          <div class="field-title">Telefonnummer</div>
                          <input v-validate="'required|numeric'"
                                 :class="{'input': true, 'is-danger': errors.has('Telefon') }"
                                 v-model.lazy="appData.contact.phone"
                                 name="Telefon"
                                 type="text">
                          <span v-show="errors.has('Telefon')"
                                class="icon icon--sort-up help is-danger">Telefon ist ein Pflichtfeld.</span>
                        </div>
                      </div>

                      <div class="stepper__input">
                        <div class="field textarea-field">
                          <div class="field-title">Falls Sie noch Anmerkungen haben, hinterlassen Sie uns gerne eine Nachricht.</div>
                          <textarea :class="{'input': true, 'is-danger': errors.has('Anfrage') }"
                                    v-model.lazy="appData.contact.anfrage"
                                    name="Anfrage"
                                    type="text" />
                          <span v-show="errors.has('Anfrage')"
                                class="help is-danger icon icon--sort-up">Anfrage ist ein Pflichtfeld.</span>
                        </div>
                      </div>
                    </div>
                    <div class="second-column">
                      <img src='/src/assets/img/5_step_Praxisbewertung_Tool.webp'>
                    </div>


                  </form>
                  <div class="privacy-checkbox">
                    <div class="stepper__input">
                      <checkbox id="app-agree"
                                v-model="appData.contact.agree"
                                name="Datenschutz">
                        Ja, ich habe die
                        <a href="https://www.gesundheitsmarkt.de/datenschutzerklaerung/"
                           target="_blank">Datenschutzerklärung</a>
                        zur Kenntnis genommen und bin mit der Verarbeitung meiner Daten im Rahmen dieser Anfrage einverstanden.
                      </checkbox>
                    </div>
                  </div>
                </div>
              </div>

              <div v-show="currentStep === 7" class="thank-you-page" style="text-align: center;">
                <div class="content-block">
                  <div class="thank-you-icon"><i class="fas fa-check-circle" /></div>
                  <h3>Ihr Praxiswert wurde erfolgreich ermittelt! </h3>
                  <span>Guten Tag {{appData.contact.anrede}} {{appData.contact.title}} {{appData.contact.lastname}},<br><br></span>
                  <span>in Kürze erhalten Sie eine E-Mail mit der indikativen Praxisbewertung für Ihre Zahnarztpraxis.</span>
                </div>
              </div>
            </Steps>
          </SlideYUpTransition>
          <div class="error-message-container">
            <div v-show="formErrorMessage"
                 class="error-message-global">{{ formErrorMessage }}</div>
          </div>
          <div class="nav">
            <button v-show="currentStep > 1 && currentStep < 6"
                    ref="stepBackwards"
                    class="button button--backwards"
                    @click="_handleStepProgress(currentStep - 1)"><span class="mobile-hidden">Zurück</span>
              <i class="fas fa-angle-left" />
            </button>
            <button v-show="currentStep >= 1 && currentStep < 5"
                    ref="stepForwards"
                    class="button button--forwards"
                    @click="_handleStepProgress(currentStep + 1)"><span class="mobile-hidden">Zum nächsten Schritt</span>
              <i class="fas fa-angle-right"></i>
            </button>
            <button v-show="currentStep == 5"
                    ref="stepForwards"
                    class="button button--forwards button--forwards"
                    @click="_handleStepProgress(currentStep + 1)">Ermitteln
            </button>
          </div>
          <div v-for="(stepTitle, index) in appData.stepTitles"
               :key="index"
               :class="{active: currentStep <= index}"
               class="stepper-not-current"
               @click="_handleStepProgress(index+1)"
               v-html="currentStep >= index+1 ? '' : `<span>${stepTitle.title}</span>`"/>
        </main>
      </div>
      {{userSource}}
      <pre v-if="dumpData"
           class="dumpData">{{ dumpData }}</pre>
    </div>
  </div>
</template>

<script>
/* Use ES6 destructuring to include only what you really need. */
import { FadeTransition, SlideXRightTransition, SlideYDownTransition, SlideYUpTransition, CollapseTransition } from 'vue2-transitions';

// import Autocomplete from "vue2-autocomplete-js";
import Autocomplete from './VueAutocomplete';
import { Checkbox, Radio, RadioGroup } from 'vue-checkbox-radio';
import vSelect from 'vue-select'
import AnimatedNumber from "animated-number-vue";


/* Adjusted version of axios with base url specified */
import axios_mail from '../config/axios_mail';

/* Import other components inside current main component */
import Steps from './Step';
import InputChoice from './InputChoice';

/* Helper functions */
import parseQuery from '../helpers/get-query-var';

/* For now only IDS should be passed */
import detectIE from '../helpers/detect-ie';
import JQuery from 'jquery'
let $j = JQuery

/* Data Strings */
import tooltipData from '../strings/tooltip-data';

const whitelabel = require('../../whitelabel.config')[BRAND_THEME];

export default {
  name: 'Index',
  filters: {
  },
  components: {
    InputChoice,
    FadeTransition,
    SlideXRightTransition,
    SlideYDownTransition,
    SlideYUpTransition,
    CollapseTransition,
    Steps,
    Autocomplete,
    Checkbox,
    vSelect,
    Radio,
    AnimatedNumber,
  },
  data() {
    return {
      testMode: false,
      queryObject: parseQuery(window.location.search),
      autocompleteResult: '',
      appCurrentLocation: window.location.href,
      stepTransitionDuration: 100,
      apiUrl: `https://public.datenmarkt-tech.de/api/zips/`,
      appPrerenderMode: PRERENDER_MODE,
      app_theme_brand: BRAND_THEME,
      app_title: whitelabel.title,
      custom_brand: whitelabel.brand,
      // Default value for local storage to save app progress
      localStorageSteps: 'pflegemarkt-steps-sks',
      localStorageData: 'pflegemarkt-data-sks',
      currentStep: 1,
      currentCompletedStep: 0,
      steps: [{ id: 1, title: 'Behandlungsspektrum' }, { id: 2, title: 'Praxisstruktur' }, { id: 3, title: 'Finanzdaten der Praxis' }, { id: 4, title: 'Nachfolge' }, { id: 5, title: 'Kontaktdaten' }, { id: 6, title: '' }, { id: 7, title: '' }, { id: 8, title: '' }],
      tooltipContent: tooltipData,
      appData: {
        usersource: '',
        stepTitles: [
          {
            title: '1. Behandlungsspektrum / Patientenstruktur'
          },
          {
            title: '2. Praxisstruktur'
          },
          {
            title: '3. Finanzdaten der Praxis'
          },
          {
            title: '4. Nachfolge'
          },
          {
            title: '5. Kontaktdaten'
          }
        ],
        s1: {
          value: '',
          services: ['Prophylaxe', 'Chirurgie', 'Zahnersatz', 'Wurzelkanalbehandlungen', 'Parodontologie', 'Kinderzahnheilkunde', 'Implantologie'],
          servicesSelected: [],
          servicesValue: -0.1,
          implantology: [
            {name: 'Ja', value: 0.1},
            {name: 'Nein', value: 0},
          ],
          implantologyValue: '',
          orthodontics: [
            {name: 'Ja', value: 0.1},
            {name: 'Nein', value: 0},
          ],
          orthodonticsValue: '',
          implantologyOther: false,
          implantologyOtherValue: '',
          angaben: [
            {name: '0% - 10%', value: -0.1},
            {name: '11% - 20%', value: -0.05},
            {name: '21% - 30%', value: -0.025},
            {name: '31% - 40%', value: 0},
            {name: '41% - 50%', value: 0},
            {name: '51% - 60%', value: 0},
            {name: '61% - 70%', value: 0.025},
            {name: '71% - 80%', value: 0.05},
            {name: '81% - 90%', value: 0.1},
            {name: '91% - 100%', value: 0.1},
          ],
          angabenValue: '',
          bills: [
            {name: '0 - 500', value: -0.1},
            {name: '501 - 1.000', value: -0.075},
            {name: '1.001 - 1.500', value: -0.05},
            {name: '1.501 - 2.000', value: -0.025},
            {name: '2.001 - 2.500', value: 0},
            {name: '2.501 - 3.000', value: 0.025},
            {name: '3.001 - 3.500', value: 0.05},
            {name: '3.501 - 4.000', value: 0.075},
            {name: '4.001 - 4.500', value: 0.01},
          ],
          billsValue: '',
        },
        s2: {
          value: '',
          rooms: [
            {name: '1-2', value: -0.2},
            {name: '3-4', value: -0.05},
            {name: '5-6', value: 0.05},
            {name: '7-8', value: 0.1},
            {name: '8+', value: 0.2},
          ],
          roomsValue: '',
          roomsEquipment: [
            {name: 'Ja', value: 0.05},
            {name: 'Nein', value: 0},
          ],
          roomsEquipmentValue: '',
          moreRooms: [
            {name: 'Ja', value: 0},
            {name: 'Nein', value: -0.1},
          ],
          moreRoomsValue: '',
          moreRoomsSecond: [
            {name: 'geringer Aufwand', value: -0.1},
            {name: 'hoher Aufwand', value: 0},
          ],
          moreRoomsSecondValue: '',
          ausstattung: [
            {name: 1, value: -0.1},
            {name: 2, value: -0.05},
            {name: 3, value: 0},
            {name: 4, value: 0.05},
            {name: 5, value: 0.1},
          ],
          // ausstattungValue: 0,
          ausstattungValue: 1,
          einrichtung: [
            {name: 1, value: -0.1},
            {name: 2, value: -0.05},
            {name: 3, value: 0},
            {name: 4, value: 0.05},
            {name: 5, value: 0.1},
          ],
          einrichtungValue: 1,
          employees: [
            {name: '0 - 10', value: -0.1},
            {name: '11 - 20', value: 0},
            {name: '21 - 30', value: 0.025},
            {name: '31 - 40', value: 0.05},
            {name: '41 - 50', value: 0.075},
            {name: '51 - 60', value: 0.1},
            {name: '61 - 70', value: 0.1},
            {name: '> 70', value: 0.1},
          ],
          employeesValue: '',
          emplyoeesDentists: 0,
          emplyoeesDentistsValue: 0,
          labaratory: [
            {name: 'Ja', value: 0.1},
            {name: 'Nein', value: -0.1},
          ],
          labaratoryValue: '',
          labaratoryEmployees: 0,
          labaratoryEmployeesValue: 0,
        },
        s3: {
          value: '',
          //todo value_front - old
          value_front: 'Deutschland gesamt',
          turnover: [
            {name: 'Umsatz < 700.000', average: 0, value: -1},
            {name: '700.001 - 900.000', average: 800000, value: -0.5},
            {name: '900.001 - 1.100.000', average: 1000000, value: -0.25},
            {name: '1.100.001 - 1.300.000', average: 1200000, value: -0.1},
            {name: '1.300.001 - 1.500.000', average: 1400000, value: 0},
            {name: '1.500.001 - 1.700.000', average: 1600000, value: 0},
            {name: '1.700.001 - 1.900.000', average: 1800000, value: 0},
            {name: '1.900.001 - 2.100.000', average: 2000000, value: 0},
            {name: '2.100.001 - 2.300.000', average: 2200000, value: 0.1},
            {name: '2.300.001 - 2.500.000', average: 2400000, value: 0.1},
            {name: '2.500.001 - 2.700.000', average: 2600000, value: 0.1},
            {name: '2.700.001 - 2.900.000', average: 2800000, value: 0.1},
            {name: '2.900.001 - 3.100.000', average: 3000000, value: 0.1},
            {name: '3.100.001 - 3.300.000', average: 3200000, value: 0.1},
            {name: '3.300.001 - 3.500.000', average: 3400000, value: 0.1},
            {name: '3.500.001 - 3.700.000', average: 3600000, value: 0.2},
            {name: '3.700.001 - 3.900.000', average: 3800000, value: 0.2},
            {name: '3.900.001 - 4.100.000', average: 4000000, value: 0.2},
            {name: '4.100.001 - 4.300.000', average: 4200000, value: 0.2},
            {name: '4.300.001 - 4.500.000', average: 4400000, value: 0.2},
            {name: '> 4.500.000', average: 4500000, value: 0.2},
          ],
          turnoverValue: '',
          surplus: [
            {name: '100.000 - 200.000', value: -0.2},
            {name: '200.001 - 300.000', value: -0.1},
            {name: '300.001 - 400.000', value: 0},
            {name: '400.001 - 500.000', value: 0.05},
            {name: '500.001 - 600.000', value: 0.1},
            {name: '600.001 - 700.000', value: 0.1},
            {name: '700.001 - 800.000', value: 0.1},
            {name: '800.001 - 900.000', value: 0.1},
            {name: '900.001 - 1.000.001', value: 0.1},
            {name: '1.000.001 - 1.100.000', value: 0.1},
            {name: '1.100.001 - 1.200.000', value: 0.2},
            {name: '1.200.001 - 1.300.000', value: 0.2},
            {name: '1.300.001 - 1.400.000', value: 0.2},
            {name: '1.400.001 - 1.500.000', value: 0.2},
          ],
          surplusValue: '',
          salesDependency: [
            {name: '0% - 10%', value: 0.3},
            {name: '11% - 20%', value: 0.2},
            {name: '21% - 30%', value: 0.1},
            {name: '31% - 40%', value: 0},
            {name: '41% - 50%', value: 0},
            {name: '51% - 60%', value: -0.05},
            {name: '61% - 70%', value: -0.1},
            {name: '71% - 80%', value: -0.2},
            {name: '81% - 90%', value: -0.4},
            {name: '91% - 100%', value: -1},
          ],
          salesDependencyValue: '',
          salesShare: [
            {name: '0% - 0,4%', value: -0.3},
            //todo 0,5% - 2,5% value FALSE in excel
            {name: '0,5% - 2,5%', value: -0.2},
            {name: '2,6% - 5%', value: -0.2},
            {name: '5,1% - 7,5%', value: -0.1},
            {name: '7,6% - 10%', value: 0},
            {name: '10,1% - 12,5%', value: 0.05},
            {name: '12,6% - 15%', value: 0.1},
            {name: '15,1% - 17,5%', value: 0.15},
            {name: '17,6% - 20%', value: 0.15},
            {name: '>20%', value: 0.2},
          ],
          salesShareValue: '',
          externalLabaratoryTurnover: [
            {name: '0', value: -0.1},
            {name: '100.000 - 200.000', value: -0.1},
            {name: '200.001 - 300.000', value: 0},
            {name: '300.001 - 400.000', value: 0.1},
            {name: '400.001 - 500.000', value: 0.1},
            {name: '500.001 - 600.000', value: 0.1},
            {name: '600.001 - 700.000', value: 0.1},
            {name: '700.001 - 800.000', value: 0.1},
            {name: '800.001 - 900.000', value: 0.1},
            {name: '900.001 - 1.000.001', value: 0.1},
            {name: '1.000.001 - 1.100.000', value: 0.1},
            {name: '1.100.001 - 1.200.000', value: 0.1},
            {name: '1.200.001 - 1.300.000', value: 0.1},
            {name: '1.300.001 - 1.400.000', value: 0.1},
            {name: '1.400.001 - 1.500.000', value: 0.1},
          ],
          externalLabaratoryTurnoverValue: '',
        },
        s4: {
          value: '',
          workAfterSale: [
            {name: '0 Jahre', value: -1},
            {name: 'Mind. 1 Jahr', value: -0.4},
            {name: 'Mind. 2 Jahre', value: -0.2},
            {name: 'Mind. 3 Jahre', value: 0},
            {name: 'Mind. 4 Jahre', value: 0.05},
            {name: 'Mind. 5 Jahre', value: 0.1},
          ],
          workAfterSaleValue: '',
          solutionTimeframe: [
            {name: '0 Monate - 6 Monate', value: 0},
            {name: '7 Monate - 12 Monate', value: 0},
            {name: '13 Monate - 18 Monate', value: -0.05},
            {name: '19 Monate - 24 Monate', value: -0.1},
            {name: '> 24 Monate', value: -0.2},
          ],
          solutionTimeframeValue: '',
          numberOfPartners: [
            {name: '1', value: 1},
            {name: '2', value: 2},
            {name: '3', value: 3},
            {name: '4', value: 4},
            {name: '5', value: 5},
            {name: '6', value: 6},
            {name: '7', value: 7},
            {name: '8', value: 8},
            {name: '9', value: 9},
            {name: '10', value: 10},
            {name: '>10', value: 11},
          ],
          numberOfPartnersValue: '',
          practiceType: [
            {name: 'Einzelpraxis', value: 1},
            {name: 'Gemeinschaftspraxis', value: 2},
            {name: 'MVZ/Gesundheitszentrum', value: 3},
            {name: 'Notfallpraxis', value: 4},
            {name: 'Tagesklinik', value: 5},
            {name: 'ÜBAG – überörtliche Berufsausübungsgemeinschaft', value: 6},
          ],
          practiceTypeValue: '',
        },
        s5: {
          value: '',
          investorInterest: 'Ja',
          resultPriceRange: '',
        },
        s6: {
          value: '',
        },
        s7: true,
        contact: {
          anrede: '',
          titel: '',
          firstname: '',
          lastname: '',
          firma: '',
          position: '',
          phone: '',
          email: '',
          anfrage: '',
          agree: false,
        }
      },
      contactFormDBKey: 0,
      formErrorMessage: ''
    };
  },
  computed: {
    implantologyOptions() {
      return this.appData.s1.implantology.map(item => ({ value: item.value, label: item.label }));
    },
    dumpData() {
      return this.queryObject.dump ? JSON.stringify(this.$data[this.queryObject.dump], null, 2) : '';
    },
    handleFormSubmit() {
      let radioausstattungValue;
      let radioeinrichtungValue;
      for(let i=0; i<this.appData.s2.ausstattung.length; i++) {
        if (this.appData.s2.ausstattung[i].name == this.appData.s2.ausstattungValue) {
          radioausstattungValue = this.appData.s2.ausstattung[i];
        }
      }

      for(let i=0; i<this.appData.s2.einrichtung.length; i++) {
        if (this.appData.s2.einrichtung[i].name == this.appData.s2.einrichtungValue) {
          radioeinrichtungValue = this.appData.s2.einrichtung[i];
        }
      }

      let postUrl;
      return axios_mail()
              .post(
                      postUrl,
                      {
                        step1: {
                          label: 'Step 1',
                          value: '',
                          valueCalc: ''
                        },
                        servicesSelected: {
                          label: 'Ganzheitliche Zahnheilkunde: ',
                          value: this.appData.s1.servicesSelected,
                          valueCalc: this.appData.s1.servicesValue
                        },
                        implantologySelected: {
                          label: 'Implantologie: ',
                          value: this.appData.s1.implantologyValue.name,
                          valueCalc: this.appData.s1.implantologyValue.value
                        },
                        orthodonticsSelected: {
                          label: 'Kieferorthopädie: ',
                          value: this.appData.s1.orthodonticsValue.name,
                          valueCalc: this.appData.s1.orthodonticsValue.value
                        },
                        implantologyOtherValue: {
                          label: 'Implantologie Sonstige: ',
                          value: this.appData.s1.implantologyOtherValue,
                          valueCalc: '-'
                        },
                        angabenValue: {
                          label: 'Anteil der Privatliquidation am Gesamtumsatz: ',
                          value: this.appData.s1.angabenValue.name,
                          valueCalc: this.appData.s1.angabenValue.value
                        },
                        billsValue: {
                          label: 'Durschnittliche Anzahl an Scheinen pro Quartal: ',
                          value: this.appData.s1.billsValue.name,
                          valueCalc: this.appData.s1.billsValue.value
                        },
                        step2: {
                          label: 'Step 2',
                          value: '',
                          valueCalc: ''
                        },
                        roomsValue: {
                          label: 'Anzahl der zahnmedizinischen Behandlungszimmer: ',
                          value: this.appData.s2.roomsValue.name,
                          valueCalc: this.appData.s2.roomsValue.value
                        },
                        roomsEquipmentValue: {
                          label: 'Kann in allen Behandlungszimmern vollumfänglich zahnmedizinisch gearbeitet werden?: ',
                          value: this.appData.s2.roomsEquipmentValue.name,
                          valueCalc: this.appData.s2.roomsEquipmentValue.value
                        },
                        moreRoomsValue: {
                          label: 'Ließe sich die Anzahl der Behandlungszimmer erweitern?: ',
                          value: this.appData.s2.moreRoomsValue.name,
                          valueCalc: this.appData.s2.moreRoomsValue.value
                        },
                        moreRoomsSecondValue: {
                          label: 'Wie hoch schätzen Sie den Aufwand der Erweiterung von Behandlungszimmern ein? Dabei ist ein geringer Aufwand mit niedrigen Investitionskosten bzw. geringem Zeitaufwand verbunden und ein hoher Aufwand mit hohen Investitionskosten bzw. erhöhtem Zeitaufwand verbunden.: ',
                          value: this.appData.s2.moreRoomsSecondValue.name,
                          valueCalc: this.appData.s2.moreRoomsSecondValue.value
                        },
                        ausstattungValue: {
                          label: 'Praxisgeräte Ausstattung - Stühle, Bohrer, CEREC etc.: ',
                          value: radioausstattungValue.name,
                          valueCalc: radioausstattungValue.value
                        },
                        einrichtungValue: {
                          label: 'Praxiseinrichtung - Wartezimmer, Rezeption, Einbauten etc.: ',
                          value: radioeinrichtungValue.name,
                          valueCalc: radioeinrichtungValue.value
                        },
                        employeesValue: {
                          label: 'Anzahl Mitarbeiter insgesamt - ZA, ZFA, ZMV, Reinigungskraft etc.: ',
                          value: this.appData.s2.employeesValue.name,
                          valueCalc: this.appData.s2.employeesValue.value
                        },
                        emplyoeesDentists: {
                          label: 'Anzahl Zahnärzte - Bitte in FTE: ',
                          value: this.appData.s2.emplyoeesDentists,
                          valueCalc: '-'
                        },
                        labaratoryValue: {
                          label: 'st in Ihrer Praxis funktionsfähiges Eigenlabor mit angestellten Technikern implementiert: ',
                          value: this.appData.s2.labaratoryValue.name,
                          valueCalc: this.appData.s2.labaratoryValue.value
                        },
                        labaratoryEmployees: {
                          label: 'Wieviele Mitarbeiter sind in Ihrem Eigenlabor beschäftigt?: ',
                          value: this.appData.s2.labaratoryEmployees,
                          valueCalc: '-'
                        },
                        step3: {
                          label: 'Step 3',
                          value: '',
                          valueCalc: ''
                        },
                        turnoverValue: {
                          label: 'Gesamtumsatz der Praxis laut BWA oder Jahresabschluss: ',
                          value: this.appData.s3.turnoverValue.name,
                          valueCalc: this.appData.s3.turnoverValue.value
                        },
                        surplusValue: {
                          label: 'Jahresüberschuss der Praxis laut BWA oder Jahresabschluss: ',
                          value: this.appData.s3.surplusValue.name,
                          valueCalc: this.appData.s3.surplusValue.value
                        },
                        salesDependencyValue: {
                          label: 'Honorarumsatz des Praxisinhabers in Relation zum Gesamtumsatz: ',
                          value: this.appData.s3.salesDependencyValue.name,
                          valueCalc: this.appData.s3.salesDependencyValue.value
                        },
                        salesShareValue: {
                          label: 'Anteil des Prophylaxe Umsatzes am Gesamtumsatz: ',
                          value: this.appData.s3.salesShareValue.name,
                          valueCalc: this.appData.s3.salesShareValue.value
                        },
                        externalLabaratoryTurnoverValue: {
                          label: 'Fremdlaborkosten im Jahr: ',
                          value: this.appData.s3.externalLabaratoryTurnoverValue.name,
                          valueCalc: this.appData.s3.externalLabaratoryTurnoverValue.value
                        },
                        step4: {
                          label: 'Step 4',
                          value: '',
                          valueCalc: ''
                        },
                        workAfterSaleValue: {
                          label: 'Wie lange sind Sie als Inhaber nach Verkauf Ihrer <br> Praxis bereit weiter in dieser tätig zu bleiben? (Idealfall 5 Jahre): ',
                          value: this.appData.s4.workAfterSaleValue.name,
                          valueCalc: this.appData.s4.workAfterSaleValue.value
                        },
                        solutionTimeframeValue: {
                          label: 'Wann wären Sie bereit sich auf eine Nachfolgelösung einzulassen?: ',
                          value: this.appData.s4.solutionTimeframeValue.name,
                          valueCalc: this.appData.s4.solutionTimeframeValue.value
                        },
                        numberOfPartnersValue: {
                          label: 'Bitte geben Sie die Anzahl der Gesellschafter Ihrer Praxis an: ',
                          value: this.appData.s4.numberOfPartnersValue.name,
                          valueCalc: this.appData.s4.numberOfPartnersValue.value
                        },
                        practiceTypeValue: {
                          label: 'Bitte geben Sie Ihren Praxis Typ an: ',
                          value: this.appData.s4.practiceTypeValue.name,
                          valueCalc: this.appData.s4.practiceTypeValue.value
                        },
                        step5: {
                          label: 'Step 5',
                          value: '',
                          valueCalc: ''
                        },
                        investorInterest: {
                          label: 'Ist Ihre Praxis interessant für Investoren?: ',
                          value: this.appData.s5.investorInterest,
                          valueCalc: '-'
                        },
                        resultPriceRange: {
                          label: 'Basiert auf dem Umsatz und den angegebenen Parametern: ',
                          value: this.appData.s5.resultPriceRange,
                          valueCalc: '-'
                        },
                        step6: {
                          label: 'Step 6',
                          value: '',
                          valueCalc: ''
                        },
                        anrede: {
                          label: 'Anrede: ',
                          value: this.appData.contact.anrede,
                          valueCalc: ''
                        },
                        title: {
                          label: 'Title: ',
                          value: this.appData.contact.title,
                          valueCalc: ''
                        },
                        lastname: {
                          label: 'Lastname: ',
                          value: this.appData.contact.lastname,
                          valueCalc: ''
                        },
                        firstname: {
                          label: 'Firstname: ',
                          value: this.appData.contact.firstname,
                          valueCalc: ''
                        },
                        company: {
                          label: 'Company: ',
                          value: this.appData.contact.firma,
                          valueCalc: ''
                        },
                        position: {
                          label: 'Position: ',
                          value: this.appData.contact.position,
                          valueCalc: ''
                        },
                        phone: {
                          label: 'Phone: ',
                          value: this.appData.contact.phone,
                          valueCalc: ''
                        },
                        email: {
                          label: 'Email: ',
                          value: this.appData.contact.email,
                          valueCalc: ''
                        },
                        anfrage: {
                          label: 'Anfrage: ',
                          value: this.appData.contact.anfrage,
                          valueCalc: ''
                        },
                        newsletter: {
                          label: 'Newsletter: ',
                          value: this.appData.contact.newsletter,
                          valueCalc: ''
                        }
                      }
              )
              .then(res => {
                if (res.data === 'ok') {
                  this._handleStepProgress(this.currentStep + 2)
                }
                //window.top.location.href = res.data.redirect_url;
              })
              .catch(error => {
                if (error.response) {
                  // The request was made and the server responded with a status code
                  // that falls out of the range of 2xx
                  console.error(error.response.data);
                  console.error(error.response.status);
                  console.error(error.response.headers);
                } else if (error.request) {
                  // The request was made but no response was received
                  // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                  // http.ClientRequest in node.js
                  console.error(error.request);
                } else {
                  // Something happened in setting up the request that triggered an Error
                  console.error('Error', error.message);
                }
                console.error(error.config);
              });
    },
    userSource() {
      if(this.queryObject.usersource) {
        this.appData.usersource = decodeURI(this.queryObject.usersource);
      }
    }
  },
  watch: {
    // Whenever the change in form appeared save status to storage
    appData: {
      handler(newData, oldData) {
        localStorage.setItem(this.localStorageData, JSON.stringify(newData));
      },
      deep: true
    },    // Whenever the change in form appeared save status to storage
    'appData.s7': {
        // This will let Vue know to look inside the array
        deep: true,
        handler() {
          this._handleIframeHeight();
        }
    }
  },
  created() {
    this.testMode = 'test' in this.queryObject;
    this.discounted = 'discounted' in this.queryObject;
    this._handleIEVersion();

    // Getting the current step from the one that stored in local storage
    if (localStorage.getItem(this.localStorageSteps) !== null) {
      const localStorageSteps = localStorage.getItem(this.localStorageSteps);
      const parsedLocalStorageData = JSON.parse(localStorageSteps);
      this.currentStep = parsedLocalStorageData.currentStep || 1;
      this.currentCompletedStep = parsedLocalStorageData.currentCompletedStep || 1;
    }

    // Grabbing the rest of data if exists
    if (localStorage.getItem(this.localStorageData) !== null) {
      const localStorageData = localStorage.getItem(this.localStorageData);
      const parsedLocalStorageData = JSON.parse(localStorageData);
      this.appData = parsedLocalStorageData;
    }

    // On created hook also send new height to iframe
    this._handleIframeHeight();
  },
  methods: {
    incrementOptionNameAusstattung() {
      if (this.appData.s2.ausstattungValue < 5) {
        this.appData.s2.ausstattungValue++;
      }
    },
    decrementOptionNameAusstattung() {
      if (this.appData.s2.ausstattungValue > 1) {
        this.appData.s2.ausstattungValue--;
      }
    },

    incrementOptionNameEinrichtung() {
      if (this.appData.s2.einrichtungValue < 5) {
        this.appData.s2.einrichtungValue++;
      }
    },
    decrementOptionNameEinrichtung() {
      if (this.appData.s2.einrichtungValue > 1) {
        this.appData.s2.einrichtungValue--;
      }
    },

    /*incrementOptionName(array, selectedArrayIndex, selectedValueProperty) {
      if (selectedArrayIndex < array.length) {
        console.log(selectedAusstattungIndex);
        selectedArrayIndex++;
        this.appData.s2[selectedValueProperty] = array[selectedArrayIndex - 1].value;
        console.log(this.appData.s2[selectedValueProperty]);
      }
    },
    decrementOptionName(array, selectedArrayIndex, selectedValueProperty) {
      if (selectedArrayIndex > 1) {
        selectedArrayIndex--;
        this.appData.s2[selectedValueProperty] = array[selectedArrayIndex - 1].value;
        console.log(this.appData.s2[selectedValueProperty]);
      }
    },*/
    incrementAnzahl() {
      if(this.appData.s2.emplyoeesDentists <= 9) {
        this.appData.s2.emplyoeesDentists++;
        this.handleInputValueDentists();
      }
    },
    decrementAnzahl() {
      if(this.appData.s2.emplyoeesDentists >= 1) {
        this.appData.s2.emplyoeesDentists--
        this.handleInputValueDentists();
      }
    },
    incrementLabaratory() {
      if(this.appData.s2.labaratoryEmployees <= 4) {
        this.appData.s2.labaratoryEmployees++;
        this.handleInputValueEmployees();
      }
    },
    decrementLabaratory() {
      if(this.appData.s2.labaratoryEmployees >= 1) {
        this.appData.s2.labaratoryEmployees--
        this.handleInputValueEmployees();
      }
    },
    handleInputValueDentists() {
      const value = this.appData.s2.emplyoeesDentists;
      if (value < 0) {
        this.appData.s2.emplyoeesDentists = 0;
      }
      switch (value) {
        case 0:
          event.target.setAttribute('value', -0.2);
          this.appData.s2.emplyoeesDentistsValue = -0.2;
          break;
        case 1:
          event.target.setAttribute('value', -0.2);
          this.appData.s2.emplyoeesDentistsValue = -0.2;
          break;
        case 2:
          event.target.setAttribute('value', -0.1);
          this.appData.s2.emplyoeesDentistsValue = -0.1;
          break;
        case 3:
          event.target.setAttribute('value', 0);
          this.appData.s2.emplyoeesDentistsValue = 0;
          break;
        case 4:
          event.target.setAttribute('value', 0.05);
          this.appData.s2.emplyoeesDentistsValue = 0.05;
          break;
        case 5:
          event.target.setAttribute('value', 0.075);
          this.appData.s2.emplyoeesDentistsValue = 0.075;
          break;
        case 6:
          event.target.setAttribute('value', 0.1);
          this.appData.s2.emplyoeesDentistsValue = 0.1;
          break;
        case 7:
          event.target.setAttribute('value', 0.125);
          this.appData.s2.emplyoeesDentistsValue = 0.125;
          break;
        case 8:
          event.target.setAttribute('value', 0.15);
          this.appData.s2.emplyoeesDentistsValue = 0.15;
          break;
        case 9:
          event.target.setAttribute('value', 0.2);
          this.appData.s2.emplyoeesDentistsValue = 0.2;
          break;
        case 10:
          event.target.setAttribute('value', 0.25);
          this.appData.s2.emplyoeesDentistsValue = 0.25;
          break;
        default:
          event.target.setAttribute('value', 0.25);
          this.appData.s2.emplyoeesDentistsValue = 0.25;
          break;
      }
    },
    handleInputValueEmployees() {
      const value = this.appData.s2.labaratoryEmployees;
      if (value < 0) {
        this.appData.s2.labaratoryEmployees = 0;
      }
      switch (value) {
        case 0:
          event.target.setAttribute('value', 0);
          this.appData.s2.labaratoryEmployeesValue = 0;
          break;
        case 1:
          event.target.setAttribute('value', 0);
          this.appData.s2.labaratoryEmployeesValue = 0;
          break;
        case 2:
          event.target.setAttribute('value', 0.05);
          this.appData.s2.labaratoryEmployeesValue = 0.05;
          break;
        case 3:
          event.target.setAttribute('value', 0.1);
          this.appData.s2.labaratoryEmployeesValue = 0.1;
          break;
        case 4:
          event.target.setAttribute('value', 0.1);
          this.appData.s2.labaratoryEmployeesValue = 0.1;
          break;
        case 5:
          event.target.setAttribute('value', 0.15);
          this.appData.s2.labaratoryEmployeesValue = 0.15;
          break;
          //todo Fix default value in excel was false
        default:
          event.target.setAttribute('value', 0.15);
          this.appData.s2.labaratoryEmployeesValue = 0.15;
          break;
      }
    },
    handleServicesList(event) {
      let value = event.length;
      switch (value) {
        case 0:
          this.appData.s1.servicesValue = -0.1;
          break;
        case 1:
          this.appData.s1.servicesValue = -0.1;
          break;
        case 2:
          this.appData.s1.servicesValue = -0.05;
          break;
        case 3:
          this.appData.s1.servicesValue = 0;
          break;
        case 4:
          this.appData.s1.servicesValue = 0.05;
          break;
        case 5:
          this.appData.s1.servicesValue = 0.1;
          break;
        default:
          this.appData.s1.servicesValue = 0.1;
          break;
      }
    },
    calculateSum() {
      let result = this.appData.s1.servicesValue
        + parseFloat(this.appData.s1.implantologyValue.value)
        + parseFloat(this.appData.s1.orthodonticsValue.value)
        + parseFloat(this.appData.s1.angabenValue.value)
        + parseFloat(this.appData.s1.billsValue.value)
        + parseFloat(this.appData.s2.ausstattungValue)
        + parseFloat(this.appData.s2.einrichtungValue)
        + parseFloat(this.appData.s2.employeesValue.value)
        + parseFloat(this.appData.s2.labaratoryValue.value)
        + parseFloat(this.appData.s2.emplyoeesDentistsValue)
        + parseFloat(this.appData.s3.turnoverValue.value)
        + parseFloat(this.appData.s3.surplusValue.value)
        + parseFloat(this.appData.s3.salesDependencyValue.value)
        + parseFloat(this.appData.s3.salesShareValue.value)
        + parseFloat(this.appData.s3.externalLabaratoryTurnoverValue.value)
        + parseFloat(this.appData.s4.solutionTimeframeValue.value);

      if (this.appData.s2.labaratoryValue.name == 'Ja') {
        result = result + parseFloat(this.appData.s2.labaratoryEmployeesValue);
      }


      result = Math.round(result * 1000) / 1000;
      let estimatePrice;
      if(this.appData.s2.emplyoeesDentistsValue < 0.075) {
        estimatePrice = this.appData.s3.turnoverValue.average*0.6*(1+result);
      } else {
        estimatePrice = this.appData.s3.turnoverValue.average*0.7*(1+result);
      }
      let priceRange;
      if (estimatePrice > 4000000) {
        priceRange = (this.numberWithCommas(Math.round((estimatePrice-500000)/10000)*10000)) +'€ - '+(this.numberWithCommas(Math.round((estimatePrice+500000)/10000)*10000))+'€';
      } else {
        if (estimatePrice < 100000) {
          estimatePrice = this.appData.s4.numberOfPartnersValue.value * 80000;
          priceRange = (this.numberWithCommas(Math.round((estimatePrice*0.8)/10000)*10000)) +'€ - '+(this.numberWithCommas(Math.round((estimatePrice*1.2)/10000)*10000))+'€';
        } else {
          priceRange = (this.numberWithCommas(Math.round((estimatePrice*0.8)/10000)*10000)) +'€ - '+(this.numberWithCommas(Math.round((estimatePrice*1.2)/10000)*10000))+'€';
        }
      }

      this.appData.s5.resultPriceRange = priceRange;
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    calculateInvestorInterest() {
      if(this.appData.s2.emplyoeesDentistsValue == -0.2 || this.appData.s3.turnoverValue.value == -1 || this.appData.s4.workAfterSaleValue.value == -1) {
        this.appData.s5.investorInterest = 'Nein';
      }
    },
    _handleIEVersion() {
      const ieVersion = detectIE(),
        ieClasses = ['ie', `ie-${ieVersion}`];

      if (ieVersion) {
        document.documentElement.classList.add(...ieClasses);
      }
    },
    _handleIframeHeight() {
      /* Remember to save reference to Vue instance */
      // const $vue = this;
      /* On step switch send new height */
      return setTimeout(function() {
        const htmlHeight = document.getElementsByTagName('html')[0].offsetHeight;
        parent.postMessage({ height: htmlHeight + 50 }, '*');
      }, this.stepTransitionDuration + 1);
    },
    _resetCalc() {
      localStorage.clear();
      location.reload();
    },
    _handleStepProgress(stepId) {
      this.calculateSum();
      this.calculateInvestorInterest();
      if (stepId === 2) {

        if (this.appData.s1.servicesSelected === '' ||
          this.appData.s1.implantologyValue === '' ||
          this.appData.s1.orthodonticsValue === '' ||
          this.appData.s1.angabenValue === '' ||
          this.appData.s1.billsValue === ''
        ) {
          this.formErrorMessage = 'Bitte füllen Sie alle Felder des Formulars aus.';
          return;
        }
        this.formErrorMessage = '';
        this.appData.s1.value = 'true';
      }

      if (stepId === 3) {
        if (this.appData.s2.roomsValue === '' ||
          this.appData.s2.roomsEquipmentValue === '' ||
          this.appData.s2.moreRoomsValue === '' ||
          this.appData.s2.ausstattungValue === '' ||
          this.appData.s2.einrichtungValue === '' ||
          this.appData.s2.employeesValue === '' ||
          this.appData.s2.emplyoeesDentistsValue === '' ||
          this.appData.s2.labaratoryValue === ''
        ) {
          this.formErrorMessage = 'Bitte füllen Sie alle Felder des Formulars aus.';
          return;
        }
        this.formErrorMessage = '';
        this.appData.s2.value = 'true';
      }

      if (stepId === 4) {
        if (this.appData.s3.turnoverValue === '' ||
          this.appData.s3.surplusValue === '' ||
          this.appData.s3.salesDependencyValue === '' ||
          this.appData.s3.salesShareValue === '' ||
          this.appData.s3.externalLabaratoryTurnoverValue === ''
        ) {
          this.formErrorMessage = 'Bitte füllen Sie alle Felder des Formulars aus.';
          return;
        }
        this.formErrorMessage = '';
        this.appData.s3.value = 'true';
      }

      if (stepId === 5) {
        if (this.appData.s4.workAfterSaleValue === '' ||
          this.appData.s4.solutionTimeframeValue === '' ||
          this.appData.s4.numberOfPartnersValue === '' ||
          this.appData.s4.practiceTypeValue === ''
        ) {
          this.formErrorMessage = 'Bitte füllen Sie alle Felder des Formulars aus.';
          return;
        }
        this.formErrorMessage = '';
        this.appData.s4.value = 'true';
      }

      if (stepId === 6) {
        for (const key in this.appData.contact) {
          if (key == 'anfrage' || key == 'newsletter' || key == 'titel') {
            continue;
          }
          if (this.appData.contact[key] === '') {
            // Scrolling to invalid input on validate
            this.$validator
              .validateAll()
              .then(result => {
                const scrollEl = document.querySelectorAll('input.is-danger')[0];
                if (!result && !!scrollEl) {
                  this.$scrollTo(scrollEl);
                }
              })
              .catch(() => {});
            this.formErrorMessage = 'Bitte füllen Sie alle Felder des Formulars aus.';
            return;
          }
          if (this.appData.contact['agree'] == false) {
            this.formErrorMessage = 'Bitte füllen Sie alle Felder des Formulars aus.';
            return;
          }
        }
        this.appData.s5.value = 'true';
        this.formErrorMessage = '';

        this.handleFormSubmit;
        return;
      }

      // Send current height to iframe
      this._handleIframeHeight();

      // Last completed step logic
      if (this.currentStep <= stepId && this.currentCompletedStep <= this.currentStep) {
        // Save recently completed step
        this.currentCompletedStep = this.currentStep;
      }

      // Go te selected step
      this.currentStep = stepId;

      // Save progress to local storage
      localStorage.setItem(
        this.localStorageSteps,
        JSON.stringify({
          currentStep: this.currentStep,
          currentCompletedStep: this.currentCompletedStep
        })
      );

      // Appendign current step to URL
      const query = { schritt: this.currentStep };
      if (this.discounted) {
        query.discounted = '';
      }
      if (this.testMode) {
        query.test = '';
      }
      this.$router.push({ query });
    },
    processJSON(json) {
      return json ? json : {};
    }
  }
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Index.vue